var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 3.5A1.5 1.5 0 0030.5 5v4.76a1.5 1.5 0 103 0V5A1.5 1.5 0 0032 3.5zM46.58 17.3a1.51 1.51 0 001.06-.44L51 13.49a1.488 1.488 0 000-2.12 1.51 1.51 0 00-2.12 0l-3.36 3.37a1.49 1.49 0 000 2.12c.282.28.662.439 1.06.44zM57.38 28.88h-4.76a1.5 1.5 0 100 3h4.76a1.5 1.5 0 000-3zM47.64 43.9a1.498 1.498 0 00-2.566.396A1.5 1.5 0 0045.52 46l3.36 3.36a1.53 1.53 0 001.06.44A1.5 1.5 0 0051 47.26l-3.36-3.36zM16.36 43.9L13 47.26a1.5 1.5 0 002.12 2.12L18.48 46a1.501 1.501 0 10-2.12-2.12v.02zM11.38 28.88H6.62a1.5 1.5 0 100 3h4.76a1.5 1.5 0 000-3zM15.12 11.37a1.51 1.51 0 00-2.447.486A1.49 1.49 0 0013 13.49l3.36 3.37a1.5 1.5 0 002.448-.485 1.49 1.49 0 00-.328-1.635l-3.36-3.37z",
    fill: "#F8B64C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.24 50.21h-6.48a1.5 1.5 0 00-1.5 1.5v4a4.74 4.74 0 009.48 0v-4a1.5 1.5 0 00-1.5-1.5z",
    fill: "#40596B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.46 29a16.52 16.52 0 10-27.25 13.88A10.76 10.76 0 0125 51v.7a1.5 1.5 0 001.5 1.5h11a1.5 1.5 0 001.5-1.5V51a11 11 0 013.88-8.21A16.409 16.409 0 0048.46 29z",
    fill: "#FFD164"
  })));
}

export default __webpack_public_path__ + "46cb8aae04e0832c0c266f55aee4188b.svg";
export { SvgLight as ReactComponent };